module.exports = __webpack_public_path__ + "img/xp-old.adccde04.svg";